module.exports = __webpack_public_path__ + "static/media/auto.b296c71c.svg";